<template>
  <div id="precios-productos">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="PRECIOS PRODUCTOS" color="primary darken-4" dark>
            <div slot="widget-content">
              <v-layout wrap class="container">
                <v-flex xs12 sm6>
                  <v-select
                    v-model="sucursalSeleccionada"
                    :items="sucursalesUsuario"
                    item-text="nombreSucursal"
                    item-value="sucursalId"
                    label="Selecciona una sucursal"
                    solo
                    return-object
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex lg12>
                  <v-card>
                    <v-toolbar card color="white">
                      <v-text-field
                        flat
                        solo
                        prepend-icon="search"
                        placeholder="Búsqueda rápida"
                        v-model="search"
                        hide-details
                        class="hidden-sm-and-down"
                      ></v-text-field>
                      <v-btn icon>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                      <v-data-table
                        :headers="headers"
                        :search="search"
                        :items="preciosProductos"
                        :rows-per-page-items="[
                          25,
                          50,
                          100,
                          { text: 'Todos', value: -1 },
                        ]"
                        class="elevation-1"
                        item-key="clienteId"
                      >
                        <template slot="items" slot-scope="props">
                          <td>
                            <v-avatar size="48">
                              <v-icon color="primary" medium
                                >attach_money</v-icon
                              >
                            </v-avatar>
                          </td>
                          <td>{{ props.item.sku }}</td>
                          <td>{{ props.item.descripcionProducto }}</td>
                          <td>{{ props.item.descripcionTalla }}</td>
                          <td>
                            <v-icon :color="props.item.codigoHtml" medium
                              >widgets</v-icon
                            >
                            {{ props.item.nombreColor }}
                          </td>
                          <td>
                            <v-text-field
                              label="Precio Venta"
                              v-model="props.item.precioVenta"
                              type="number"
                              prefix="$"
                              :rules="[
                                () =>
                                  props.item.precioVenta >= 0 ||
                                  'No puede ser negativo!',
                              ]"
                              @change="updatePrecioCatalogo(props.item)"
                            ></v-text-field>
                          </td>
                          <td>
                            <v-text-field
                              label="Precio Renta"
                              v-model="props.item.precioRenta"
                              type="number"
                              prefix="$"
                              :rules="[
                                () =>
                                  props.item.precioRenta >= 0 ||
                                  'No puede ser negativo!',
                              ]"
                              @change="updatePrecioCatalogo(props.item)"
                            ></v-text-field>
                          </td>
                          <td>
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="pink"
                              small
                              @click="deleteCliente(props.item.catalogoRowId)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>
                        <v-alert
                          slot="no-results"
                          :value="true"
                          color="error"
                          icon="warning"
                          outline
                          >La búsqueda para "{{ search }}" no encontró
                          registros</v-alert
                        >
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

import catalogoProductoService from "@/services/catalogoProductoService";

export default {
  components: {
    VWidget,
    confirm,
    loadingAlert,
    snackBar,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "", align: "center", sortable: false },
        {
          text: "SKU",
          align: "center",
          value: "sku",
        },
        { text: "PRODUCTO", align: "center", value: "descripcionProducto" },
        { text: "TALLA", align: "center", value: "descripcionTalla" },
        { text: "COLOR", align: "center", value: "nombreColor" },
        { text: "PRECIO VENTA", align: "center", value: "precioVenta" },
        { text: "PRECIO RENTA", align: "center", value: "precioRenta" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      sucursalesUsuario: [],
      sucursalSeleccionada: {
        sucursalId: 0,
        nombreSucursal: "",
      },
      preciosProductos: [],
      precioProducto: {
        catalogoRowId: 0,
        sku: "",
        productoId: 0,
        descripcionProducto: "",
        tallaId: 0,
        descripcionTalla: "",
        colorId: 0,
        nombreColor: "",
        codigoHtml: "",
        precioVenta: 0,
        precioRenta: 0,
      },
    };
  },
  mounted() {
    let self = this;
    try {
      let current_user = this.$store.state.currentUser;
      this.sucursalesUsuario = current_user.sucursales;
      if (this.sucursalesUsuario.length > 0) {
        this.sucursalSeleccionada = this.sucursalesUsuario[0];
      }
    } catch (e) {
      self.codeFailed(
        "Ocurrió un error al extraer sucursales, es posible que se haya perdido la sesión o no tengas sucursales asignadas"
      );
    }
  },
  watch: {
    sucursalSeleccionada: function (n) {
      this.getPreciosProductos(n.sucursalId);
    },
  },
  methods: {
    getPreciosProductos(sucursalId) {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      catalogoProductoService
        .getPreciosProductos(sucursalId)
        .then((result) => {
          self.preciosProductos = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    updatePrecioCatalogo(catalogoProducto) {
      let self = this;
      catalogoProductoService
        .update(catalogoProducto)
        .then((result) => {
          self.$store.state.snackbar.color = "success";
          self.$store.state.snackbar.text = "Precios actualizados";
          self.$store.state.snackbar.visible = true;
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
  },
};
</script>
